// Benchmark comparison + Risk-adjusted performance tables, side by side.
// Mirrors TradingView's "Benchmark comparison" and "Risk-adjusted performance" cards.

import type { BacktestResponseDto } from "../../api/types";
import { selectPrimary } from "./primary";

interface Props {
  result: BacktestResponseDto;
}

export function BenchmarkTable({ result }: Props) {
  const primary = selectPrimary(result);
  if (!primary) {
    return (
      <div style={{ padding: 12, background: "#161b22", borderRadius: 4, fontSize: 12, color: "#8b949e" }}>
        No benchmark data.
      </div>
    );
  }
  // bhReturn is on Merge; for scans we use buyHoldReturn.
  const bh = "bhReturn" in primary ? primary.bhReturn : primary.buyHoldReturn;
  const strat = primary.totalReturn;
  const outperformance = strat - bh;
  return (
    <div style={{ background: "#0d1117", border: "1px solid #30363d", borderRadius: 6, padding: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Benchmark comparison</div>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
        <tbody>
          <Row label="Buy & hold return" value={fmtPct(bh)} color={bh >= 0 ? "#3fb950" : "#f85149"} />
          <Row label="Strategy return"   value={fmtPct(strat)} color={strat >= 0 ? "#3fb950" : "#f85149"} />
          <Row label="Strategy outperformance" value={fmtPct(outperformance)} color={outperformance >= 0 ? "#3fb950" : "#f85149"} bold />
        </tbody>
      </table>
    </div>
  );
}

function Row({ label, value, color, bold }: { label: string; value: string; color?: string; bold?: boolean }) {
  return (
    <tr style={{ borderTop: "1px solid #21262d" }}>
      <td style={{ padding: "8px 8px", color: "#8b949e", fontSize: 12 }}>{label}</td>
      <td style={{
        padding: "8px 8px",
        textAlign: "right",
        color: color ?? "#c9d1d9",
        fontFamily: "monospace",
        fontSize: 12,
        fontWeight: bold ? 700 : 400,
      }}>
        {value}
      </td>
    </tr>
  );
}

function fmtPct(n: number): string {
  if (!Number.isFinite(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
}
